(function() { window.GUID_a8c35ad6_25f9_4c08_9b4f_b8f7bc78aaf3 = { getGuid: function() { return "a8c35ad6-25f9-4c08-9b4f-b8f7bc78aaf3"; } }; })();
var CS;
(function (CS) {
    var Enumeration;
    (function (Enumeration) {
        let PictureType;
        (function (PictureType) {
            PictureType[PictureType["Player"] = 0] = "Player";
            PictureType[PictureType["Team"] = 1] = "Team";
            PictureType[PictureType["Event"] = 2] = "Event";
            PictureType[PictureType["NewsFeed"] = 3] = "NewsFeed";
        })(PictureType = Enumeration.PictureType || (Enumeration.PictureType = {}));
    })(Enumeration = CS.Enumeration || (CS.Enumeration = {}));
})(CS || (CS = {}));

//# sourceMappingURL=PictureType.pre.js.map
